import React from 'react'

import styles from './CartSizePicker.module.css'
import cx from '../../../utils/className'

import ColorPicker from '../../common/ColorPicker/ColorPicker'

import withQuickAdd from '../../../hooks/withQuickAdd'
import withCartAndPlugins from '../../../hooks/withCartAndPlugins'

const activatesPickerButton = (key) => key === 'Enter' || key === ' '

const CartSizePicker = props => {
  const { selectedOptions = [] } = props.product || {}
  const { $i18n } = props
  const originSelectedVariant = {}

  selectedOptions.forEach(item => {
    originSelectedVariant[item.name] = item.value
  })

  const handleQuickAdd = () => {
    if (props.disabled) {
      return
    }
    props.onQuickAdd({
      product: props.product,
      selectedVariantId: props.product.id
    })
  }

  const handleKeyDown = (e) => {
    if (props.disabled || !activatesPickerButton(e.key)) return
    if (e.key === ' ') {
      e.preventDefault()
    }
    handleQuickAdd()
  }

  const sizeValue = selectedOptions.filter(item => item.name === 'Size')[0].value
  const inseamValue = (selectedOptions.filter(item => item.name === 'Inseam')[0] || {}).value

  const variantSummary = selectedOptions.map(o => o.value).filter(Boolean).join(' / ')
  const ariaLabel = variantSummary || $i18n.transl('core.cart.cartChangeVariant')

  return (
    <div
      className={cx(styles.sizePicker, props.isDesktop && styles.pc, props.className)}
      role="button"
      tabIndex={props.disabled ? -1 : 0}
      aria-label={ariaLabel}
      aria-disabled={props.disabled ? true : undefined}
      onClick={handleQuickAdd}
      onKeyDown={handleKeyDown}
    >
      {
        Object.keys(props.colorSwatch).length === 0
          ? <span className={styles.sizeValue}>{props.value}</span>
          : (
            <>
              <ColorPicker active={false} colorSwatchItem={props.colorSwatch} imageClass={cx(styles.imageClass, props.colorPickerImageClass)} className={styles.colorPicker} />
              <span className={styles.sizeValue}>/ {sizeValue} {inseamValue && `(${inseamValue})`}</span>
            </>
          )
      }
      {
        !props.disabled && <span className={styles.sizePickerIcon} aria-hidden="true">&#xe7b2;</span>
      }
    </div>
  )
}

export default withQuickAdd(withCartAndPlugins(CartSizePicker))